import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import { setError } from "./error";

import AuthService from "../../services/authGuestService";

const accessToken = JSON.parse(localStorage.getItem("token-guest"));

export const login = createAsyncThunk(
    "authGuest/login",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.login({ formData });
            return { token: response.accessToken };
        } catch (error) {
            const errorValidation = error.response && error.response.data && error.response.data.errors;
            thunkAPI.dispatch(setError(errorValidation));
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const logout = createAsyncThunk(
    "authGuest/logout", 
    async () => {
        await AuthService.logout();
    }
);

export const getGuestDetails = createAsyncThunk(
    'authGuest/getGuestDetails',
    async (arg, { getState, rejectWithValue }) => {
      try {
            const data = await AuthService.getGuest();
                return { guest: data.data.guest };
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

const initialState = {
    loading: false,
    isLoggedIn: accessToken ? true : false,
    token: accessToken ? accessToken : null,
    guest: null
}

const authGuestSlice = createSlice({
    name: "authGuest",
    initialState,
    extraReducers: {
        [login.pending]: (state) => {
            state.loading = true
        },
        [login.fulfilled]: (state, action) => {
         //   console.log(action)
            state.loading = false;
            state.isLoggedIn = true;
            state.token = action.payload.token;
        },
        [login.rejected]: (state, action) => {
            state.loading = false;
            state.isLoggedIn = false;
            state.token = null;
        },
        [logout.fulfilled]: (state, action) => {
            state.isLoggedIn = false;
            state.guest = null;
        },
        [getGuestDetails.pending]: (state) => {
            state.loading = true
        },
        [getGuestDetails.fulfilled]: (state, action) => {
            state.loading = false
            state.guest = action.payload.guest
        },
        [getGuestDetails.rejected]: (state, action) => {
            state.loading = false
        },
    },
});

const { reducer } = authGuestSlice;
export default reducer;